import firebase from "firebase";
import { Observable } from "rxjs/internal/Observable";
import router from "@/router";
import { ScreenType } from '@/enum/screen.type';
class AuthService {
  signInWithPopup(provider: any): Observable<any> {
    return new Observable(subscriber => {
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          subscriber.next(result);
          subscriber.complete();
        })
        .catch(error => {
          subscriber.next(error);
          subscriber.complete();
        });
    });
  }

  signWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return this.signInWithPopup(provider);
  }

  signWithFacebook() {
    const provider = new firebase.auth.FacebookAuthProvider();
    return this.signInWithPopup(provider);
  }

  signWithTwitter() {
    const provider = new firebase.auth.TwitterAuthProvider();
    return this.signInWithPopup(provider);
  }

  getCurrentAuth(): Observable<any> {
    return new Observable(subcriber => {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          subcriber.next(user);
          subcriber.complete();
        } else {
          subcriber.next(user);
          subcriber.complete();
        }
      });
    });
  }

  signOut() {
    return firebase.auth().signOut().then(() => {
      router.push({name: ScreenType.login})
    })
  }
}

export default new AuthService();
